import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Tracks when a user enables/disables inactivity logout',
  name: 'enabled_or_disabled_inactivity_logout',
  params: [
    {
      description: 'binary value captures whether feature was enabled or disabled',
      name: 'inactivity_logout_enabled',
      required: false,
      type: 'boolean',
    },
    {
      description: 'Timeout period (in seconds)',
      name: 'inactivity_logout_timeout_duration',
      required: false,
      type: 'number',
    },
  ],
};

export default META;
